export default __webpack_public_path__ + "static/media/1056.ad81ff89.png";